var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNavigationArrowLeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(-110 -11.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "External",
    transform: "translate(39 0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_13037",
    "data-name": "Rectangle 13037",
    transform: "translate(71 11)",
    fill: "#fff",
    stroke: "#212121",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 15,
    height: 15,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "backward",
    transform: "translate(75.7 14.645) rotate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Page-1",
    d: "M5.352,11.791a.5.5,0,0,1-.363-.156L-.362,6a.5.5,0,0,1,0-.69l5.4-5.657a.5.5,0,0,1,.707-.016.5.5,0,0,1,.016.707L.69,5.658l5.024,5.288a.5.5,0,0,1-.362.844Z",
    fill: "#212121"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigationArrowLeft);
export default __webpack_public_path__ + "static/media/navigation_arrow_left.673c123adbeda861f35713c7920f5daf.svg";
export { ForwardRef as ReactComponent };